<!-- Input Dropdown Template -->
<ng-template #input_dropdown_template>
  @if (options && options.length > 0) {
    <p-dropdown inputId="{{ name }}"
      class="{{ dropdownClass }}"
      appendTo="body"
      ariaLabelledBy="{{ name }}_label"
      styleClass="{{ inputClass }}"
      panelStyleClass="{{ menuClass }}"
      formControlName="{{ name }}"
      [disableControl]="disabled"
      [showClear]="showClear"
      [options]="options"
      [autofocus]="autofocus"
      optionLabel="{{ optionLabel }}"
      optionValue="{{ optionValue }}"
      [placeholder]="placeholder | translate"
      [filter]="(filter === undefined ? options.length >= FlatModels.DropdownDesignModels.DropDownMinFilterLimit : filter)"
              [ngClass]="{
                'ng-invalid': control.invalid && control.touched,
                'ng-dirty': control.invalid && control.touched
              }"
      (onChange)="valueChange.emit($event)">
      <ng-template pTemplate="selectedItem">
        <div class="flex align-items-center gap-2">
          <div class="overflow-hidden text-overflow-ellipsis">{{ getLabel(control.value) | translate }}&nbsp;</div>
        </div>
      </ng-template>
      <ng-template let-entry pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div class="overflow-hidden text-overflow-ellipsis">{{ entry[optionLabel] | translate }}</div>
        </div>
      </ng-template>
    </p-dropdown>
  }
  @if (control.invalid && (control.dirty || control.touched)) {
    <br/>
    @for (err of control.errors | keyvalue; track err) {
      <small id="{{ name }}_help"
        class="p-error">
        {{ err.value | translate }}
      </small>
      <br/>
    }
  }
</ng-template>
<!-- Drop Down Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1 flex-row column-gap-2"
        [class.mb-2]="!formField"
        for="{{ name }}">
        @if (labelIcon) {
          <i class="{{ labelIcon }}"></i>
        }
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    @if (!inputGroup) {
      <ng-container *ngTemplateOutlet="input_dropdown_template"></ng-container>
    } @else {
      <div medsurf-design-content-input-group>
        <ng-container *ngTemplateOutlet="input_dropdown_template"></ng-container>
        <ng-content></ng-content>
      </div>
    }
  </div>
}